import type { IconProps } from "@/components/icons/types";
import AccessTimeFilled from "@/components/icons/AccessTimeFilled";
import ArrowRight from "@/components/icons/ArrowRight";
import ArrowRightAlt from "@/components/icons/ArrowRightAlt";
import ArrowUpward from "@/components/icons/ArrowUpward";
import Award from "@/components/icons/Award";
import CalendarMonth from "@/components/icons/CalendarMonth";
import CalendarToday from "@/components/icons/CalendarToday";
import Certificate from "./Certificate";
import CertificateRibbon from "./CertificateRibbon";
import Check from "@/components/icons/Check";
import CheckListCheck from "@/components/icons/CheckListCheck";
import ChevronLeft from "@/components/icons/ChevronLeft";
import ChevronRight from "@/components/icons/ChevronRight";
import Circle from "@/components/icons/Circle";
import CircleCheck from "@/components/icons/CircleCheck";
import CirclePlay from "@/components/icons/CirclePlay";
import CircleCloseFill from "./CircleCloseFill";
import Clock from "@/components/icons/Clock";
import Close from "@/components/icons/Close";
import ClosePopup from "@/components/icons/ClosePopup";
import Compass from "@/components/icons/Compass";
import CreditCard from "@/components/icons/CreditCard";
import CustomerService from "@/components/icons/CustomerService";
import Dash from "@/components/icons/Dash";
import Degrees from "@/components/icons/Degrees";
import EarnSkills from "./EarnSkills";
import EdxBy2U from "@/components/icons/EdxBy2U";
import EventBusy from "@/components/icons/EventBusy";
import Facebook from "@/components/icons/Facebook";
import Filters from "@/components/icons/Filters";
import FormatQuote from "@/components/icons/FormatQuote";
import Groups from "@/components/icons/Groups";
import Info from "@/components/icons/Info";
import Instructor from "@/components/icons/Instructor";
import KeyboardArrowDown from "@/components/icons/KeyboardArrowDown";
import KeyboardArrowUp from "@/components/icons/KeyboardArrowUp";
import Language from "@/components/icons/Language";
import Laptop from "@/components/icons/Laptop";
import Launch from "@/components/icons/Launch";
import Level from "@/components/icons/Level";
import LibraryBooks from "@/components/icons/LibraryBooks";
import Lightbulb from "@/components/icons/Lightbulb";
import LinkedIn from "@/components/icons/LinkedIn";
import LocationOn from "@/components/icons/LocationOn";
import Mail from "@/components/icons/Mail";
import Money from "@/components/icons/Money";
import MoneyOutline from "@/components/icons/MoneyOutline";
import Monitor from "@/components/icons/Monitor";
import NumberOfCourses from "@/components/icons/NumberOfCourses";
import Pacing from "@/components/icons/Pacing";
import PartOfProgram from "@/components/icons/PartOfProgram";
import People from "@/components/icons/People";
import Person from "@/components/icons/Person";
import PlayCircle from "@/components/icons/PlayCircle";
import PlayCircleFilled from "@/components/icons/PlayCircleFilled";
import Program from "@/components/icons/Program";
import Reddit from "@/components/icons/Reddit";
import Sale from "./Sale";
import School from "@/components/icons/School";
import Search from "@/components/icons/Search";
import SeeLess from "@/components/icons/SeeLess";
import SeeMore from "@/components/icons/SeeMore";
import StarFilled from "@/components/icons/StarFilled";
import StarOutline from "@/components/icons/StarOutline";
import TimeToComplete from "@/components/icons/TimeToComplete";
import Timelapse from "@/components/icons/Timelapse";
import Trencher from "@/components/icons/Trencher";
import TrendingPoints from "@/components/icons/TrendingPoints";
import TrendingUp from "@/components/icons/TrendingUp";
import Twitter from "@/components/icons/Twitter";
import X from "@/components/icons/X";
import Warning from "@/components/icons/Warning";
import WarningCircle from "@/components/icons/WarningCircle";
import OpenQuote from "./OpenQuote";
import Speedometer from "./Speedometer";
import FacebookCircle from "./FacebookCircle";
import LinkedInCircle from "./LinkedInCircle";
import CircleCheckOutline from "./CircleCheckOutline";
import TodoList from "./TodoList";
import CalendarChecked from "./CalendarChecked";
import CircleCheckFill from "./CircleCheckFill";
import PlayArrow from "./PlayArrow";
import Institution from "./Institution";
import ContentCopy from "./ContentCopy";
import SubtitlesOff from "./SubtitlesOff";
import VisibilityIcon from "./Visibility";
import VisibilityOffIcon from "./VisibilityOff";
import OutlineWarningCircle from "./OutlineWarningCircle";
import AddShoppingCart from "./AddShoppingCart";
import BookOpen from "./BookOpen";
import Briefcase from "./Briefcase";
import AI from "./AI";
import Business from "./Business";
import Data from "./Data";
import Popular from "./Popular";
import StartDate from "./StartDate";
import Trending from "./Trending";
import SchoolOutline from "./SchoolOutline";
import VerifiedOutline from "./VerifiedOutline";
import ChatBubble from "./ChatBubble";
import MagnifyingGlass from "@/components/icons/MagnifyingGlass";
import CloseMaterial from "@/components/icons/CloseMaterial";
import KeyboardArrowDownMaterial from "@/components/icons/KeyboardArrowDownMaterial";
import ShieldCheck from "@/components/icons/ShieldCheck";
import QuestionAnswer from "./QuestionAnswer";
import IosShare from "./IosShare";
import LearningPath from "./LearningPath";
import LoadingSpinner from "./LoadingSpinner";
import BulletedList from "./BulletedList";
import Article from "./Article";
import VerifiedBadge from "./VerifiedBadge";

const Icon = ({ svgProps, pathProps, type }: IconProps) => {
  switch (type) {
    case "access-time-filled":
      return <AccessTimeFilled svgProps={svgProps} pathProps={pathProps} />;
    case "add-shopping-cart":
      return <AddShoppingCart svgProps={svgProps} pathProps={pathProps} />;
    case "ai":
      return <AI svgProps={svgProps} pathProps={pathProps} />;
    case "arrow-right":
      return <ArrowRight svgProps={svgProps} pathProps={pathProps} />;
    case "arrow-right-alt":
      return <ArrowRightAlt svgProps={svgProps} pathProps={pathProps} />;
    case "arrow-upward":
      return <ArrowUpward svgProps={svgProps} pathProps={pathProps} />;
    case "award":
      return <Award svgProps={svgProps} pathProps={pathProps} />;
    case "business":
      return <Business svgProps={svgProps} pathProps={pathProps} />;
    case "calendar-month":
      return <CalendarMonth svgProps={svgProps} pathProps={pathProps} />;
    case "calendar-today":
      return <CalendarToday svgProps={svgProps} pathProps={pathProps} />;
    case "certificate":
      return <Certificate svgProps={svgProps} pathProps={pathProps} />;
    case "certificate-ribbon":
      return <CertificateRibbon svgProps={svgProps} pathProps={pathProps} />;
    case "check":
      return <Check svgProps={svgProps} pathProps={pathProps} />;
    case "check-list-check":
      return <CheckListCheck svgProps={svgProps} pathProps={pathProps} />;
    case "chevron-left":
      return <ChevronLeft svgProps={svgProps} pathProps={pathProps} />;
    case "chevron-right":
      return <ChevronRight svgProps={svgProps} pathProps={pathProps} />;
    case "circle":
      return <Circle svgProps={svgProps} pathProps={pathProps} />;
    case "circle-check":
      return <CircleCheck svgProps={svgProps} pathProps={pathProps} />;
    case "circle-check-outline":
      return <CircleCheckOutline svgProps={svgProps} pathProps={pathProps} />;
    case "circle-check-fill":
      return <CircleCheckFill svgProps={svgProps} pathProps={pathProps} />;
    case "circle-play":
      return <CirclePlay svgProps={svgProps} pathProps={pathProps} />;
    case "circle-close-fill":
      return <CircleCloseFill svgProps={svgProps} pathProps={pathProps} />;
    case "clock":
      return <Clock svgProps={svgProps} pathProps={pathProps} />;
    case "close":
      return <Close svgProps={svgProps} pathProps={pathProps} />;
    case "close-popup":
      return <ClosePopup svgProps={svgProps} pathProps={pathProps} />;
    case "compass":
      return <Compass svgProps={svgProps} pathProps={pathProps} />;
    case "credit-card":
      return <CreditCard svgProps={svgProps} pathProps={pathProps} />;
    case "customer-service":
      return <CustomerService svgProps={svgProps} pathProps={pathProps} />;
    case "dash":
      return <Dash svgProps={svgProps} pathProps={pathProps} />;
    case "data":
      return <Data svgProps={svgProps} pathProps={pathProps} />;
    case "degrees":
      return <Degrees svgProps={svgProps} pathProps={pathProps} />;
    case "earn-skills":
      return <EarnSkills svgProps={svgProps} pathProps={pathProps} />;
    case "edx-by-2u":
      return <EdxBy2U svgProps={svgProps} pathProps={pathProps} />;
    case "event-busy":
      return <EventBusy svgProps={svgProps} pathProps={pathProps} />;
    case "facebook":
      return <Facebook svgProps={svgProps} pathProps={pathProps} />;
    case "facebook-circle":
      return <FacebookCircle svgProps={svgProps} pathProps={pathProps} />;
    case "filters":
      return <Filters svgProps={svgProps} pathProps={pathProps} />;
    case "format-quote":
      return <FormatQuote svgProps={svgProps} pathProps={pathProps} />;
    case "groups":
      return <Groups svgProps={svgProps} pathProps={pathProps} />;
    case "info":
      return <Info svgProps={svgProps} pathProps={pathProps} />;
    case "instructor":
      return <Instructor svgProps={svgProps} pathProps={pathProps} />;
    case "keyboard-arrow-down":
      return <KeyboardArrowDown svgProps={svgProps} pathProps={pathProps} />;
    case "keyboard-arrow-up":
      return <KeyboardArrowUp svgProps={svgProps} pathProps={pathProps} />;
    case "language":
      return <Language svgProps={svgProps} pathProps={pathProps} />;
    case "laptop":
      return <Laptop svgProps={svgProps} pathProps={pathProps} />;
    case "launch":
      return <Launch svgProps={svgProps} pathProps={pathProps} />;
    case "learning-path":
      return <LearningPath svgProps={svgProps} pathProps={pathProps} />;
    case "level":
      return <Level svgProps={svgProps} pathProps={pathProps} />;
    case "location-on":
      return <LocationOn svgProps={svgProps} pathProps={pathProps} />;
    case "library-books":
      return <LibraryBooks svgProps={svgProps} pathProps={pathProps} />;
    case "lightbulb":
      return <Lightbulb svgProps={svgProps} pathProps={pathProps} />;
    case "linkedin":
      return <LinkedIn svgProps={svgProps} pathProps={pathProps} />;
    case "linkedin-circle":
      return <LinkedInCircle svgProps={svgProps} pathProps={pathProps} />;
    case "loading-spinner":
      return <LoadingSpinner svgProps={svgProps} pathProps={pathProps} />;
    case "mail":
      return <Mail svgProps={svgProps} pathProps={pathProps} />;
    case "money":
      return <Money svgProps={svgProps} pathProps={pathProps} />;
    case "money-outline":
      return <MoneyOutline svgProps={svgProps} pathProps={pathProps} />;
    case "monitor":
      return <Monitor svgProps={svgProps} pathProps={pathProps} />;
    case "number-of-courses":
      return <NumberOfCourses svgProps={svgProps} pathProps={pathProps} />;
    case "open-quote":
      return <OpenQuote svgProps={svgProps} pathProps={pathProps} />;
    case "pacing":
      return <Pacing svgProps={svgProps} pathProps={pathProps} />;
    case "part-of-program":
      return <PartOfProgram svgProps={svgProps} pathProps={pathProps} />;
    case "people":
      return <People svgProps={svgProps} pathProps={pathProps} />;
    case "person":
      return <Person svgProps={svgProps} pathProps={pathProps} />;
    case "play-arrow":
      return <PlayArrow svgProps={svgProps} pathProps={pathProps} />;
    case "play-circle":
      return <PlayCircle svgProps={svgProps} pathProps={pathProps} />;
    case "play-circle-filled":
      return <PlayCircleFilled svgProps={svgProps} pathProps={pathProps} />;
    case "popular":
      return <Popular svgProps={svgProps} pathProps={pathProps} />;
    case "program":
      return <Program svgProps={svgProps} pathProps={pathProps} />;
    case "reddit":
      return <Reddit svgProps={svgProps} pathProps={pathProps} />;
    case "sale":
      return <Sale svgProps={svgProps} pathProps={pathProps} />;
    case "school":
      return <School svgProps={svgProps} pathProps={pathProps} />;
    case "school-outline":
      return <SchoolOutline svgProps={svgProps} pathProps={pathProps} />;
    case "search":
      return <Search svgProps={svgProps} pathProps={pathProps} />;
    case "see-less":
      return <SeeLess svgProps={svgProps} pathProps={pathProps} />;
    case "shield-check":
      return <ShieldCheck svgProps={svgProps} pathProps={pathProps} />;
    case "see-more":
      return <SeeMore svgProps={svgProps} pathProps={pathProps} />;
    case "speedometer":
      return <Speedometer svgProps={svgProps} pathProps={pathProps} />;
    case "star-filled":
      return <StarFilled svgProps={svgProps} pathProps={pathProps} />;
    case "star-outline":
      return <StarOutline svgProps={svgProps} pathProps={pathProps} />;
    case "start-date":
      return <StartDate svgProps={svgProps} pathProps={pathProps} />;
    case "time-to-complete":
      return <TimeToComplete svgProps={svgProps} pathProps={pathProps} />;
    case "timelapse":
      return <Timelapse svgProps={svgProps} pathProps={pathProps} />;
    case "trencher":
      return <Trencher svgProps={svgProps} pathProps={pathProps} />;
    case "trending":
      return <Trending svgProps={svgProps} pathProps={pathProps} />;
    case "trending-points":
      return <TrendingPoints svgProps={svgProps} pathProps={pathProps} />;
    case "trending-up":
      return <TrendingUp svgProps={svgProps} pathProps={pathProps} />;
    case "twitter":
      return <Twitter svgProps={svgProps} pathProps={pathProps} />;
    case "verified-outline":
      return <VerifiedOutline svgProps={svgProps} pathProps={pathProps} />;
    case "warning":
      return <Warning svgProps={svgProps} pathProps={pathProps} />;
    case "warning-circle":
      return <WarningCircle svgProps={svgProps} pathProps={pathProps} />;
    case "outline-warning-circle":
      return <OutlineWarningCircle svgProps={svgProps} pathProps={pathProps} />;
    case "x":
      return <X svgProps={svgProps} pathProps={pathProps} />;
    case "todo-list":
      return <TodoList svgProps={svgProps} pathProps={pathProps} />;
    case "calendar-checked":
      return <CalendarChecked svgProps={svgProps} pathProps={pathProps} />;
    case "institution":
      return <Institution svgProps={svgProps} pathProps={pathProps} />;
    case "content-copy":
      return <ContentCopy svgProps={svgProps} pathProps={pathProps} />;
    case "subtitles-off":
      return <SubtitlesOff svgProps={svgProps} pathProps={pathProps} />;
    case "visibility":
      return <VisibilityIcon svgProps={svgProps} pathProps={pathProps} />;
    case "visibility-off":
      return <VisibilityOffIcon svgProps={svgProps} pathProps={pathProps} />;
    case "book-open":
      return <BookOpen svgProps={svgProps} pathProps={pathProps} />;
    case "business":
      return <Business svgProps={svgProps} pathProps={pathProps} />;
    case "briefcase":
      return <Briefcase svgProps={svgProps} pathProps={pathProps} />;
    case "chat-bubble":
      return <ChatBubble svgProps={svgProps} pathProps={pathProps} />;
    case "magnifying-glass":
      return <MagnifyingGlass svgProps={svgProps} pathProps={pathProps} />;
    case "close-material":
      return <CloseMaterial svgProps={svgProps} pathProps={pathProps} />;
    case "keyboard-arrow-down-material":
      return (
        <KeyboardArrowDownMaterial svgProps={svgProps} pathProps={pathProps} />
      );
    case "question-answer":
      return <QuestionAnswer svgProps={svgProps} pathProps={pathProps} />;
    case "questionAnswer": // monarch enums do not allow for hyphens. Duplicating to maintin usability.
      return <QuestionAnswer svgProps={svgProps} pathProps={pathProps} />;
    case "ios-share":
      return <IosShare svgProps={svgProps} pathProps={pathProps} />;
    case "iosShare": // monarch enums do not allow for hyphens. Duplicating to maintin usability.
      return <IosShare svgProps={svgProps} pathProps={pathProps} />;
    case "bulleted-list":
      return <BulletedList svgProps={svgProps} pathProps={pathProps} />;
    case "article":
      return <Article svgProps={svgProps} pathProps={pathProps} />;
    case "verified-badge":
      return <VerifiedBadge svgProps={svgProps} pathProps={pathProps} />;
    default:
      return null;
  }
};

export default Icon;

export {
  AccessTimeFilled,
  AI,
  ArrowRight,
  ArrowRightAlt,
  ArrowUpward,
  Award,
  Business,
  CalendarMonth,
  CalendarToday,
  Certificate,
  Check,
  CheckListCheck,
  ChevronLeft,
  ChevronRight,
  Circle,
  CircleCheck,
  CircleCheckFill,
  CirclePlay,
  Clock,
  Close,
  ClosePopup,
  Compass,
  ContentCopy,
  SubtitlesOff,
  CreditCard,
  CustomerService,
  Data,
  Dash,
  Degrees,
  EdxBy2U,
  EventBusy,
  Facebook,
  FacebookCircle,
  Filters,
  FormatQuote,
  Groups,
  Instructor,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Language,
  Laptop,
  Launch,
  Level,
  LibraryBooks,
  Lightbulb,
  LinkedIn,
  LinkedInCircle,
  LoadingSpinner,
  LocationOn,
  Mail,
  Money,
  MoneyOutline,
  Monitor,
  NumberOfCourses,
  OpenQuote,
  Pacing,
  PartOfProgram,
  People,
  Person,
  PlayCircle,
  PlayCircleFilled,
  Popular,
  Program,
  Reddit,
  School,
  Search,
  SeeLess,
  SeeMore,
  ShieldCheck,
  Speedometer,
  StarFilled,
  StarOutline,
  StartDate,
  TimeToComplete,
  Timelapse,
  Trencher,
  Trending,
  TrendingPoints,
  TrendingUp,
  Twitter,
  X,
  Warning,
  WarningCircle,
  OutlineWarningCircle,
  ChatBubble,
  MagnifyingGlass,
  CloseMaterial,
  KeyboardArrowDownMaterial,
  QuestionAnswer,
  IosShare,
  VerifiedBadge,
};
